// Components==============
import storePortfolio from 'actions/portfolio/store';
import { useReduxAction } from 'hooks/useReduxAction';
import updatePortfolio from 'actions/portfolio/update';
import destroyPortfolio from 'actions/portfolio/destroy';
import { EvidenceState } from 'typings';
import { useConfirm } from 'hooks/useConfirm';
import { useTranslate } from 'hooks/useTranslate';
import { useAlert } from 'hooks/useAlert';
import { MyPortfolioContextType } from './MyPortfolio';
// =========================

export type MyPortfolioFunctions = ReturnType<typeof useMyPortfolioFunctions>;

export function useMyPortfolioFunctions({
  currentPortfolio,
  currentPortfolioId,
  setSelectedPortfolio,
  portfolios,
}: MyPortfolioContextType) {
  const dispatch = useReduxAction();
  const confirm = useConfirm();
  const translate = useTranslate();
  const alert = useAlert();

  function handleAddPortfolio(name: string) {
    const nameExists = portfolios?.map((p) => p?.name).includes(name);

    if (nameExists) return alert(translate('general.terms.name-exists'));

    dispatch(storePortfolio({ name })).then(() =>
      setSelectedPortfolio(name || '')
    );
  }

  function handleDeletePortfolio(id: number) {
    confirm(translate('portfolio.confirm.delete-portfolio'), () =>
      dispatch(destroyPortfolio(id)).then(() =>
        setSelectedPortfolio(portfolios?.[0]?.name || '')
      )
    );
  }

  function handleDeletePortfolioItem(c: EvidenceState) {
    confirm(translate('course.confirm.delete'), () =>
      dispatch(
        updatePortfolio({
          detachEvidence: true,
          portfolio: currentPortfolioId,
          evidence: c.evidenceId,
        })
      )
    );
  }

  function handleEditPortfolioName(val: string, id: number) {
    dispatch(
      updatePortfolio({
        name: val,
        id,
      })
    ).then(() => setSelectedPortfolio(val || ''));
  }

  function handleChangeVisibility() {
    dispatch(
      updatePortfolio({
        visibility:
          currentPortfolio?.visibility === 'private' ? 'public' : 'private',
        id: currentPortfolioId,
      })
    );
  }

  function handleChangeLayout(layout: GridOptions) {
    dispatch(
      updatePortfolio({
        layout,
        id: currentPortfolioId,
      })
    );
  }

  function handleUrlChange(val: string) {
    dispatch(
      updatePortfolio({
        share_code: val,
        id: currentPortfolioId,
      })
    ).catch(() => alert(translate('portfolio.errors.sharecode-update-failed')));
  }

  // hanldeEvidenceUpload from project functions
  // function handleEvidenceUpload({
  //   file,
  //   link,
  //   processId,
  // }: {
  //   file?: File;
  //   link?: string;
  //   processId: number;
  // }) {
  //   const values = {
  //     uploadNewEvidence: true,
  //     processId,
  //     processType: 'App\\ProjectProcess',
  //   };

  //   dispatch(
  //     updateProcess(
  //       file ? { ...values, file } : { ...values, link, type: 'extern' }
  //     )
  //   );
  // }

  // placeholder
  const handleEvidenceUpload = () => {};

  function handleReorder(evidence: { id: number; order: number }[]) {
    dispatch(
      updatePortfolio({
        updateOrder: true,
        id: currentPortfolioId,
        evidence,
      })
    );
  }

  return {
    handleAddPortfolio,
    handleDeletePortfolio,
    handleDeletePortfolioItem,
    handleEditPortfolioName,
    handleChangeLayout,
    handleUrlChange,
    handleChangeVisibility,
    handleReorder,
    handleEvidenceUpload,
  };
}
